document.querySelectorAll('.card__media').forEach(function(card) {
  let startX;
  let endX;

  // Καταγραφή της αρχικής θέσης του δαχτύλου
  card.addEventListener('touchstart', function(event) {
    startX = event.changedTouches[0].screenX;
  });

  // Καταγραφή της τελικής θέσης του δαχτύλου και σύγκριση
  card.addEventListener('touchend', function(event) {
    endX = event.changedTouches[0].screenX;
    
    if (endX < startX) { // Αν ο χρήστης σέρνει το δάχτυλο προς τα αριστερά
      card.classList.add('swiped');  // Ενεργοποιούμε την αλλαγή εικόνας
    } else if (endX > startX) { // Αν ο χρήστης σέρνει το δάχτυλο προς τα δεξιά
      card.classList.remove('swiped');  // Επιστρέφουμε στην αρχική εικόνα
    }
  });
});
